<template>
    <PublicPageLayout :heading="heading">
        <p>{{ message }}</p>
    </PublicPageLayout>
</template>

<script>
import PublicPageLayout from './components/PublicPageLayout.vue'

export default {
    name: 'ExpiredInvite',
    components: { PublicPageLayout },
    computed: {
        heading() {
            return this.$t('§public.expired_invite_heading')
        },
        message() {
            return this.$t('§public.expired_invite_message')
        },
    },
}
</script>
